import React from 'react'

import { useRecipe } from '../../model/context'
import { Text, FontFamily, FontWeight, Color } from '@gousto-internal/citrus-react'
import { useRecipeCookingTime } from '../../model/recipe'

export const CookingTimeText = () => {
  const { isFineDineIn } = useRecipe()
  const cookingTime = useRecipeCookingTime()

  if (!cookingTime) {
    return null
  }

  return (
    <Text
      size={2}
      fontFamily={FontFamily.Book}
      fontWeight={FontWeight.Normal}
      color={isFineDineIn ? Color.White : Color.ColdGrey_600}
    >
      {cookingTime + ' mins'}
    </Text>
  )
}
